<!--  -->
<template>
  <div>
    <el-tag v-for="itemr,index in arr" :key="index" class="tag_box">{{ itemr }}</el-tag>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      arr: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    sendr(arr) {
      this.arr = arr
      console.log('arrs', arr)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tag_box{
  margin: 0 10px 10px 0px;
}
</style>
